/* eslint-disable */

import {SystemRole} from "@/utils/SystemRole";
import {HorseStatus} from "@/utils/HorseStatus";

export const HorseUtils = {
    canDeleteHorse(horseStatus, systemRole) {
        if (SystemRole.ADMIN === systemRole) {
            return true;
        } else if (SystemRole.THIRD_LEVEL_EDITOR === systemRole && horseStatus !== HorseStatus.REGISTER_IN_STUDBOOK) {
            return true;
        } else if ((SystemRole.THIRD_LEVEL_EDITOR === systemRole || SystemRole.FIRST_LEVEL_EDITOR || SystemRole.THIRD_LEVEL_EDITOR) &&
            (horseStatus === HorseStatus.NEW_FOAL || horseStatus === HorseStatus.NEW_IMPORTED)) {
            return true;
        }

        return false;
    },

    getHorseEditUrl(horseStatus, id) {
        switch (horseStatus) {
            case HorseStatus.NEW_FOAL:
            case HorseStatus.WAITING_FOR_MARKING_DATA:
                return "/horse/foal/" + id;
            case HorseStatus.NEW_IMPORTED:
                return "/horse/import/" + id;
            case HorseStatus.WAITING_FOR_LABORATORY:
                return "/laboratory/horses/form/" + id;
            case HorseStatus.LABORATORY_DATA_ENTERED:
                return "/horse/foal/" + id;
            default:
                return "/horse/edit/" + id;
        }
    }
};


